<div class="container-md" [ngClass]="{ 'px-0': isMessagePage() }">
  @if(!isCertificatePage() && !isMessagePage() && selectedAuction().idTenantEntity === 1)
  {
  <div class="row mt-3">
    <div class="col-12 d-flex justify-content-end">
        <button type="button" id="infoDropdown" (click)="openAuctionInfo()"
          [class.gold-auction]="isMemorabid() && !inPreEventStatus()"
          [class.marketplace-auction]="!isMemorabid() && !inPreEventStatus()"
        [class.preEvent-auction]="inPreEventStatus()">
        <span *ngIf="isMemorabid() && !inPreEventStatus()">{{
          "IDS_MEMORABID_WHAT_IS" | translate
          }}</span>
        <span *ngIf="!isMemorabid() && !inPreEventStatus()">{{
          "IDS_MARKETPLACE_WHAT_IS" | translate
          }}</span>
        <span *ngIf="inPreEventStatus()">{{
          "IDS_PRE_EVENT_AUCTIONS_WHAT_IS" | translate
          }}</span>
      </button>
    </div>
  </div>
  }
  <div class="row mt-2" *ngIf="
      !isCertificatePage() && authService.isAuthenticated() && !isMessagePage()
    ">
    <div class="d-flex justify-content-end">
      <div class="bidImageBottomLeft losing me-auto" *ngIf="
          !selectedAuction().isFinished &&
          !isPreEventFinished() &&
          selectedAuction().currentUserOffered &&
          selectedAuction().currentMaxIDUserBidder !=
            authService.userLogged.idUser
        ">
        <div class="bid-info-icon">
          <fa-icon [icon]="faExclamation" size="sm"></fa-icon>
        </div>
        <span class="bidImageText text-uppercase">{{
          "IDS_OFFER_OUTBID" | translate
          }}</span>
      </div>
      <div class="bidImageBottomLeft winning me-auto" *ngIf="
          selectedAuction().reservePriceReached &&
          !selectedAuction().isFinished &&
          !isPreEventFinished() &&
          selectedAuction().currentUserOffered &&
          selectedAuction().currentMaxIDUserBidder ==
            authService.userLogged.idUser
        ">
        <div class="bid-info-icon">
          <fa-icon [icon]="faCheck" size="sm"></fa-icon>
        </div>
        <span class="bidImageText text-uppercase">{{
          "IDS_OFFER_HIGHER" | translate
          }}</span>
      </div>
      <div class="bidImageBottomLeft reserve-price-not-reached me-auto" *ngIf="
          !selectedAuction().reservePriceReached &&
          !selectedAuction().isFinished &&
          !isPreEventFinished() &&
          selectedAuction().currentUserOffered &&
          selectedAuction().currentMaxIDUserBidder ==
            authService.userLogged.idUser
        ">
        <div class="bid-info-icon">
          <fa-icon [icon]="faExclamation" size="sm"></fa-icon>
        </div>
        <span class="bidImageText text-uppercase">{{
          "IDS_OFFER_HIGHER_RESERVE_NOT_REACHED" | translate
          }}</span>
      </div>
      <div *ngIf="!isFavorite()">
        <button type="button" (click)="addToFavorites($event)" class="heart-icon" [ngClass]="{
            'heart-icon-gold': isMemorabid() && !inPreEventStatus(),
            'heart-icon-marketplace': !isMemorabid() && !inPreEventStatus(),
            'heart-icon-preEvent': inPreEventStatus()
          }">
          <fa-icon [icon]="faHeartRegular" size="lg"></fa-icon>
        </button>
      </div>
      <div *ngIf="isFavorite()">
        <button type="button" (click)="removeFromFavorites()" class="heart-icon" [ngClass]="{
            'heart-icon-gold': isMemorabid() && !inPreEventStatus(),
            'heart-icon-marketplace': !isMemorabid() && !inPreEventStatus(),
            'heart-icon-preEvent': inPreEventStatus()
          }">
          <fa-icon [icon]="faHeart" size="lg"></fa-icon>
        </button>
      </div>
    </div>
  </div>
  @if(!isMessagePage()){
  <div class="row mt-2">
    <div class="col-12">
      <h3 class="auction-title text-uppercase">
        {{ title() }}
      </h3>
    </div>
  </div>
  }
  
  @if(selectedAuction().idTenantEntity === 1) {
  <div class="row" *ngIf="
      !isMemorabid() && !isCertificatePage() && !isMessagePage() && !inPreEventStatus()
    ">
    <div class="col-md-12 d-flex align-items-center">
      <span class="bid-marketplace">
        {{ "IDS_SELLER" | translate }}
        <a [routerLink]="[
            '/',
            languageService.userSelectedLanguage.code,
            'seller',
            selectedAuction().idEntitySeller
          ]">{{ selectedAuction().entitySellerName }}</a>
      </span>
    </div>
  </div>
  @if(isMemorabid() && !isMessagePage() && !inPreEventStatus()){
  <div class="row">
    <div class="col-md-12 d-flex align-items-center">
      <img class="icon" src="/assets/img/memorabid-icon.svg" alt="Memorabid" />
      <span class="bid-gold">
        {{ "IDS_SELLER_MEMORABID" | translate }}
      </span>
    </div>
  </div>}
  }

  @if(!isMessagePage() && inPreEventStatus()){
  <div class="row">
    <div class="col-md-12 d-flex align-items-center">
      <img class="icon" src="/assets/img/memorabid-icon-pre-event.svg" alt="Memorabid_PreEvent" />
      <span class="bid-preEvent">
        {{ "IDS_PRE_EVENT_NOW" | translate
        }}{{ !!selectedAuction().eventTagId ? ":" : "" }}
        <a *ngIf="!!selectedAuction().eventTagId" [routerLink]="[
            '/',
            languageService.userSelectedLanguage.code,
            'tags',
            selectedAuction().eventTagDescription.toLowerCase()
          ]" class="nowrap">{{ selectedAuction().eventTagDescription }}</a>
      </span>
    </div>
  </div>}
  <div class="row" *ngIf="selectedAuction().campaignTitleList[0] != null && !isMessagePage()">
    <div class="col-md-12 d-flex align-items-center">
      <img alt="campaign" class="icon" [src]="selectedAuction().fullCampaignEntityLogoPath+'?w=100'" />
      <span [class.bid-gold]="isMemorabid() && !inPreEventStatus()"
        [class.bid-marketplace]="!isMemorabid() && !inPreEventStatus()" [class.bid-preEvent]="inPreEventStatus()">
        {{ "IDS_COLLABORATION_WITH" | translate }}
        <span class="nowrap">
          <a [routerLink]="
              ([
                '/',
                languageService.userSelectedLanguage.code,
                'campaign',
                selectedAuction().idCampaign
              ])
            ">{{
            selectedAuction().campaignTitleList[0].title
            }}</a>
        </span>
      </span>
    </div>
  </div>
  <div class="row" *ngIf="selectedAuction().promoterTitleList[0] != null && !isMessagePage()">
    <div class="col-md-12 d-flex align-items-center">
      <img alt="promoter" class="icon" [src]="selectedAuction().fullPromoterLogoPath+'?w=100'" />
      <span [class.bid-gold]="isMemorabid() && !inPreEventStatus()"
        [class.bid-marketplace]="!isMemorabid() && !inPreEventStatus()" [class.bid-preEvent]="inPreEventStatus()">
        {{ "IDS_PROMOTED" | translate }}
        <span class="nowrap">
          <a [routerLink]="
              ([
                '/',
                languageService.userSelectedLanguage.code,
                'promoter',
                selectedAuction().idPromoter
              ])
            ">{{ selectedAuction().promoterTitleList[0].title }}</a>
        </span>
      </span>
    </div>
  </div>
  <div class="row mt-4 align-items-end" *ngIf="sportIds()" [ngClass]="{
      'article__word--medium-screen': !isMessagePage(),
      'message__word--medium-screen': isMessagePage(),
      'mx-0': isMessagePage()
    }">
    <div class="info col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3" [ngClass]="{ 'px-0': isMessagePage() }">
      <span>
        {{ "IDS_SPORT" | translate }}
      </span>
    </div>
    <div class="col">
      <span [ngClass]="{ 'message__text-start': isMessagePage() }">
        {{ sportIds() | translate }}
      </span>
    </div>
  </div>
  <div class="row mt-3 align-items-end" *ngIf="competitionIds()" [ngClass]="{
      'article__word--medium-screen': !isMessagePage(),
      'message__word--medium-screen': isMessagePage(),
      'mx-0': isMessagePage()
    }">
    <div class="info col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3" [ngClass]="{ 'px-0': isMessagePage() }">
      <span>
        {{ "IDS_COMPETITION" | translate }}
      </span>
    </div>
    <div class="col">
      <span [ngClass]="{ 'message__text-start': isMessagePage() }">
        {{ competitionIds() | translate }}
      </span>
    </div>
  </div>
  <div class="row mt-3 align-items-end" *ngIf="teamIds()" [ngClass]="{
      'article__word--medium-screen': !isMessagePage(),
      'message__word--medium-screen': isMessagePage(),
      'mx-0': isMessagePage()
    }">
    <div class="info col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3" [ngClass]="{ 'px-0': isMessagePage() }">
      <span>
        {{ "IDS_TEAM" | translate }}
      </span>
    </div>
    <div class="col">
      <span [ngClass]="{ 'message__text-start': isMessagePage() }">
        {{ teamIds() | translate }}
      </span>
    </div>
  </div>

  @for(property of selectedAuction().article.articlePropertyList; track property){
  <div>
    <div *ngIf="
        property.value &&
        property.value !== 'false' &&
        property.name !== 'Sport' &&
        property.name !== 'Competizione' &&
        property.name !== 'Squadra'
      " class="row mt-3 align-items-end" [ngClass]="{
        'article__word--medium-screen': !isMessagePage(),
        'message__word--medium-screen': isMessagePage(),
        'mx-0': isMessagePage()
      }">
      <div class="info col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3" [ngClass]="{ 'px-0': isMessagePage() }">
        <span>
          {{ property.translationKey | translate }}
        </span>
      </div>
      <div class="col">
        <span *ngIf="property.value !== 'true'" [ngClass]="{ 'message__text-start': isMessagePage() }">
          {{ property.value }}
        </span>
        <fa-icon class="correct" [icon]="faCheckCircle" *ngIf="property.value === 'true'">
        </fa-icon>
        <fa-icon class="warning" [icon]="faTimesCircle" *ngIf="property.value === 'false'">
        </fa-icon>
      </div>
    </div>
  </div>
  }
</div>